import script from "./dro-dlg-login.vue?vue&type=script&lang=ts&setup=true"
export * from "./dro-dlg-login.vue?vue&type=script&lang=ts&setup=true"

import "./dro-dlg-login.vue?vue&type=style&index=0&id=0d4f46ec&lang=scss"

const __exports__ = script;

export default __exports__